var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-area-container"},[_c('DataFrom',{on:{"submit":_vm.handleSubmit}}),_c('h3',[_vm._v(" "+_vm._s(_vm.title)+" "),_c('span',[_vm._v(_vm._s(_vm.subTitle))])]),_c('DataList',{attrs:{"list":_vm.list}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }